import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-500 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="text-xl font-bold whitespace-nowrap">
              91.con <span className="text-accent-300">导航</span>
            </Link>
            <p className="mt-3 text-sm text-white/70 leading-relaxed">
              91.con 官方入口最新地址导航，提供安全访问指引、常见问题解答与使用教程，帮助用户快速找到官方渠道。
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-white/70 hover:text-white transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-white/70 hover:text-white transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/latest-address" className="text-sm text-white/70 hover:text-white transition-colors whitespace-nowrap">
                  最新地址
                </Link>
              </li>
              <li>
                <Link to="/category/faq" className="text-sm text-white/70 hover:text-white transition-colors whitespace-nowrap">
                  常见问题
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-white/70 hover:text-white transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-white/70">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base"></i>
                <span>contact@91con-nav.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-base"></i>
                <span>安全认证 · HTTPS加密</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-base"></i>
                <span>7×24小时更新维护</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-white/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50">
            &copy; {currentYear} 91.con 导航站. 本站为非官方导航页面，仅为用户提供地址索引服务。
          </p>
          <div className="flex items-center gap-4 text-xs text-white/50">
            <Link to="/about" className="hover:text-white/80 transition-colors whitespace-nowrap">
              关于我们
            </Link>
            <Link to="/category/safety-tips" className="hover:text-white/80 transition-colors whitespace-nowrap">
              安全须知
            </Link>
            <Link to="/category/faq" className="hover:text-white/80 transition-colors whitespace-nowrap">
              常见问题
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}